import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import {
  Folder as FolderIcon,
  FolderSpecial as FolderSpecialIcon,
} from '@mui/icons-material';
import { useProjectsContext } from '../context/ProjectsContext';
import { useBatchUploadHandler } from '../hooks/BatchUploadHandler';

const EmptyState: React.FC = () => {
  const { isScanning } = useProjectsContext();
  const { handleBatchFolderSelect } = useBatchUploadHandler();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      textAlign="center"
    >
      <FolderIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        No projects yet
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        Upload your first project folder to start managing files
      </Typography>
      <Button
        variant="contained"
        size="large"
        startIcon={
          isScanning ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            <FolderSpecialIcon />
          )
        }
        onClick={handleBatchFolderSelect}
        disabled={isScanning}
      >
        Upload Projects
      </Button>
    </Box>
  );
};

export default EmptyState;
